import angular from "angular";
import uiRouter from "angular-ui-router";

import referencesComponent from "./references.component";
import welcomescreenComponent from "./scenes/welcomescreen/welcomescreen.component";
import questiononeComponent from "./scenes/questionone/questionone.component";
import questiontwoComponent from "./scenes/questiontwo/questiontwo.component";
import questionthreeComponent from "./scenes/questionthree/questionthree.component";
import questionfourComponent from "./scenes/questionfour/questionfour.component";
import questionfiveComponent from "./scenes/questionfive/questionfive.component";
import questionsixComponent from "./scenes/questionsix/questionsix.component";
import confirmationComponent from "./scenes/confirmation/confirmation.component";

let referencesModule = angular
  .module("references", [uiRouter, "cleave.js"])
  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
    $stateProvider
      .state("references?rid", {
        url: "/references",
        template: "<references></references>",
        title: "Post a Job",
        params: {
          rid: null,
        },
      })
      .state("references-welcome-screen", {
        url: "/references/welcome?rid",
        template: "<references></references>",
        title: "Welcome",
        params: {
          rid: null,
        },
      })
      .state("references-question-one", {
        url: "/references/question-one?rid",
        template: "<references></references>",
        title: "Question 1",
        params: {
          rid: null,
        },
      })
      .state("references-question-two", {
        url: "/references/question-two?rid",
        template: "<references></references>",
        title: "Question 2",
        params: {
          rid: null,
        },
      })
      .state("references-question-three", {
        url: "/references/question-three?rid",
        template: "<references></references>",
        title: "Question 3",
        params: {
          rid: null,
        },
      })
      .state("references-question-four", {
        url: "/references/question-four?rid",
        template: "<references></references>",
        title: "Question 4",
        params: {
          rid: null,
        },
      })
      .state("references-question-five", {
        url: "/references/question-five?rid",
        template: "<references></references>",
        title: "Question 5",
        params: {
          rid: null,
        },
      })
      .state("references-question-six", {
        url: "/references/question-six?rid",
        template: "<references></references>",
        title: "Question 6",
        params: {
          rid: null,
        },
      })
      .state("confirmation", {
        url: "/references/confirmation?rid",
        template: "<references></references>",
        title: "Confirmation",
        params: {
          rid: null,
        },
      });
  })
  .component("references", referencesComponent)
  .component("welcomescreen", welcomescreenComponent)
  .component("questionone", questiononeComponent)
  .component("questiontwo", questiontwoComponent)
  .component("questionthree", questionthreeComponent)
  .component("questionfour", questionfourComponent)
  .component("questionfive", questionfiveComponent)
  .component("questionsix", questionsixComponent)
  .component("confirmation", confirmationComponent);

export default referencesModule;



// WEBPACK FOOTER //
// ./client/app/scenes/references/references.js